var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/helpers/extends", "prop-types", "react", "./Button.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/helpers/extends"), require("prop-types"), require("react"), require("./Button.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.propTypes, global.react, global.Button);
    global.Button = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _propTypes, _react, _Button) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);

  var Button = function Button(_ref) {
    var ariaExpanded = _ref.ariaExpanded,
        ariaLabel = _ref.ariaLabel,
        ariaLabelledBy = _ref.ariaLabelledBy,
        isTextBlack = _ref.isTextBlack,
        className = _ref.className,
        href = _ref.href,
        html = _ref.html,
        icon = _ref.icon,
        _ref$icons = _ref.icons,
        icons = _ref$icons === void 0 ? [] : _ref$icons,
        id = _ref.id,
        label = _ref.label,
        onClick = _ref.onClick,
        onKeyPress = _ref.onKeyPress,
        role = _ref.role,
        style = _ref.style,
        isLink = _ref.isLink,
        type = _ref.type,
        target = _ref.target;
    var ariaProps = {};

    if (ariaLabel) {
      ariaProps['aria-label'] = ariaLabel;
    }

    if (ariaLabelledBy) {
      ariaProps['aria-labelledby'] = ariaLabelledBy;
    }

    var EnsuredButton = isLink ? _Button.StyledButton.withComponent('a', {
      target: "e12632o50",
      label: "EnsuredButton"
    }) : _Button.StyledButton;
    return /*#__PURE__*/_react.default.createElement(EnsuredButton, (0, _extends2.default)({
      href: href,
      type: type,
      id: id,
      className: className,
      onClick: onClick,
      onKeyPress: onKeyPress
    }, ariaProps, {
      "aria-expanded": ariaExpanded,
      role: role,
      style: style,
      target: isLink ? target : undefined
    }), /*#__PURE__*/_react.default.createElement(_Button.StyledWrapper, null, icon, (label.length > 0 || html.length === 0) && /*#__PURE__*/_react.default.createElement(_Button.StyledButtonValue, {
      isTextBlack: isTextBlack
    }, label), label.length === 0 && html.length > 0 && /*#__PURE__*/_react.default.createElement(_Button.StyledButtonValue, {
      isTextBlack: isTextBlack,
      dangerouslySetInnerHTML: {
        __html: html
      }
    }), icons.length > 0 && icons.map(function (iconOrImage, iconIndex) {
      return /*#__PURE__*/_react.default.cloneElement(iconOrImage, {
        key: "icons-key-".concat(iconIndex)
      });
    })));
  };

  Button.propTypes = {
    ariaExpanded: _propTypes.default.bool,
    ariaLabel: _propTypes.default.string,
    ariaLabelledBy: _propTypes.default.string,
    className: _propTypes.default.string,
    isTextBlack: _propTypes.default.bool,
    href: _propTypes.default.string,
    html: _propTypes.default.string,
    icon: _propTypes.default.node,
    icons: _propTypes.default.arrayOf(_propTypes.default.node),
    id: _propTypes.default.string,
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func,
    onKeyPress: _propTypes.default.func,
    role: _propTypes.default.string,
    style: _propTypes.default.shape(),
    type: _propTypes.default.string,
    isLink: _propTypes.default.bool,
    target: _propTypes.default.string
  };
  Button.defaultProps = {
    ariaLabel: '',
    ariaLabelledBy: '',
    isTextBlack: false,
    isLink: false,
    href: null,
    html: '',
    label: '',
    style: {},
    target: null
  };
  var _default = Button;
  _exports.default = _default;
});